/**
 * @module common/components/sorting_form
 */
import React, { PropTypes } from 'react';
import RemoteSubmitField from 'common/containers/form_fields';
import { SelectField } from 'common/components/form_fields';

/**
 * Sorting form for different lists of elements. It uses our SelectField that
 * submits the form after selecting an option.
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 *
 * @returns {node} SortingForm - form component
 */
const SortingForm = ({ handleSubmit, sortingOptions, formName, onChange, disabled }) => (
  <div className="small-16 column controls-form sorting">
    <form
      onSubmit={handleSubmit}
    >
      <div className="controls-group">
        <h5 className="sorting-name">Sort</h5>
        <RemoteSubmitField
          classes="sorting"
          fieldName="sorting"
          formName={formName}
          component={SelectField}
          options={sortingOptions}
          onChange={onChange}
          disabled={disabled}
        />
      </div>
    </form>
  </div>
);

/**
 * PropTypes.
 *
 * @property {string} formName - name of the form, used to append to field names
 * @property {array} sortingOptions - list of sorting options to render
 * @property {bool} disabled - boolean value that sets the form fields to disabled
 * @property {func} onChange - function called when option is selected
 * @property {func} handleSubmit - built-in redux-form function
 */
SortingForm.propTypes = {
  formName: PropTypes.string,
  sortingOptions: PropTypes.array,
  disabled: PropTypes.bool,
  handleSubmit: PropTypes.func,
  onChange: PropTypes.func,
};

export default SortingForm;



// WEBPACK FOOTER //
// ./common/components/sorting_form.jsx